<template>
  <v-container fluid class="pa-0 px-3">
    <loading
      :active.sync="loading"
      :can-cancel="false"
      :is-full-page="true"
      :height="150"
      :width="150"
      :color="'#FFFF00'"
      :background-color="'#000000'"
      :opacity="0.5"
    ></loading>

    <!-- Sticky header: buttons + title -->
    <div style="position:sticky;top:0;z-index:20;background:#ffffff;padding:0;">
      <div class="mystaff-btn-bar">
        <v-btn class="fbtn fbtn-cancel mr-2" @click="backHandler">
          <v-icon size="16" class="mr-1">mdi-arrow-left</v-icon>
          {{ $t("button.back") }}
        </v-btn>
      </div>
      <h2 class="mystaff-page-title">
        <v-icon size="20" color="#1261a0" class="mr-2" style="vertical-align:middle;">{{ getCategoryIcon(category) }}</v-icon>
        {{ parentObject.list.title }}
        <span style="color:#546e7a;font-weight:400;font-size:0.95rem;"> &mdash; </span>
        <span style="color:#4CAF50;font-size:0.95rem;">{{ parentObject.list.startDate }}</span>
        <span style="color:#546e7a;font-weight:400;font-size:0.95rem;"> until </span>
        <span style="color:#4CAF50;font-size:0.95rem;">{{ parentObject.list.endDate }}</span>
      </h2>
    </div>

    <v-snackbar v-model="showErrSnack" color="error" top :timeout="4000">
      {{ errMsg }}
      <template v-slot:action="{ attrs }">
        <v-btn text v-bind="attrs" @click="showErrSnack = false">Close</v-btn>
      </template>
    </v-snackbar>

    <!-- Main content card -->
    <div class="mystaff-main-card">
      <v-container fluid class="px-4 pb-4">

        <!-- Filter bar -->
        <v-row class="mt-3 mb-1 align-center">
          <v-col cols="12" md="6" class="py-0">
            <v-select
              v-model="temporaryRole"
              :items="roleOptions"
              label="Select Role to view"
              outlined
              dense
              hide-details
            ></v-select>
          </v-col>
          <v-col cols="auto" class="py-0">
            <v-btn class="fbtn fbtn-secondary" @click="refreshList(temporaryRole)">
              <v-icon size="16" class="mr-1">mdi-refresh</v-icon>
              Refresh
            </v-btn>
          </v-col>
          <v-col
            v-if="(category === 'KPI' || category === 'Review') && show"
            cols="12" md="3" class="py-0"
          >
            <v-text-field
              v-model="searchQuery"
              dense
              hide-details
              outlined
              append-icon="mdi-magnify"
              clearable
              placeholder="Search..."
            ></v-text-field>
          </v-col>
        </v-row>

        <!-- Selected role chip -->
        <v-row v-if="show && selectedRole" class="mt-2 mb-0">
          <v-col cols="12" class="py-0">
            <span class="role-chip">
              <v-icon size="13" class="mr-1" style="color:inherit;">mdi-account-group</v-icon>
              {{ selectedRole }}
            </span>
          </v-col>
        </v-row>

        <!-- Reward table -->
        <my-staff-table
          v-if="category === 'Reward' && show"
          :table-data="tableData"
          :search-query.sync="searchQuery"
          :parent-object="parentObject"
        />

        <!-- KPI / Review staff list -->
        <my-staff-list
          v-if="(category === 'KPI' || category === 'Review') && show"
          :category="parentObject.list.category"
          :staff-list="currentStaffList"
          :search-query="searchQuery"
          :expand-all-flag="expandAllFlag"
          @view-kpi-details="handleViewDetails"
          @view-review-details="handleViewReviewDetails"
          @expand-all="expandAll"
          @collapse-all="collapseAll"
        />

      </v-container>
    </div>
  </v-container>
</template>

<script>
import MyStaffList from "./MyStaffList.vue";
import MyStaffTable from "./MyStaffTable.vue";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import moment from "moment";

export default {
  components: {
    MyStaffList,
    MyStaffTable,
    Loading,
  },
  props: {
    parentObject: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      category: this.parentObject.list.category,
      selectedRole: null,
      temporaryRole: null,
      show: false,
      roleOptions: [],
      roleMap: {},
      searchQuery: "",
      expandAllFlag: false,
      currentStaffList: [],
      loading: false,
      tableData: [],
      errMsg: '',
      showErrSnack: false,
    };
  },
  watch: {
    errMsg(val) {
      if (val) this.showErrSnack = true;
    },
  },
  methods: {
    backHandler() {
      this.$router.push({ name: "selfservicemystaff" });
    },

    getCategoryIcon(category) {
      if (category === "KPI") return "mdi-target";
      if (category === "Review") return "mdi-clipboard-text-outline";
      if (category === "Reward") return "mdi-trophy-outline";
    },

    loadRoleOptions() {
      const vm = this;
      let URL;
      if (vm.category === "KPI") URL = "/ss/mystaffkpiexercise/roleoptions/";
      else if (vm.category === "Review") URL = "/ss/mystaffreviewexercise/roleoptions/";
      else if (vm.category === "Reward") URL = "/ss/mystaffrewardexercise/roleoptions/";

      return this.$store
        .dispatch("get", { url: URL + this.parentObject.list.id })
        .then((res) => {
          res.data.rec.forEach((item) => vm.roleOptions.push(item.role));
          vm.roleMap = res.data.rec;
        })
        .catch(function (err) {
          vm.errMsg = err;
        });
    },

    async refreshList(roleName) {
      this.loading = true;
      const vm = this;
      if (!roleName) { this.loading = false; return; }

      this.currentStaffList = [];
      this.searchQuery = "";
      this.show = false;

      const roleObj = this.roleMap.find((item) => item.role === roleName);
      const roleId = roleObj ? roleObj.id : null;
      if (!roleId) { this.loading = false; return; }

      this.selectedRole = roleName;

      if (this.category === "Reward") {
        try {
          const res = await vm.$store.dispatch("get", {
            url: `/ss/mystaffrewardsimulate/stafflist/${vm.$store.getters.staffId}/${vm.parentObject.list.id}/${roleId}`,
          });
          res.data.rec.forEach((item) => {
            if (item.reviewfromdate) item.reviewfromdate = moment(item.reviewfromdate).format("DD-MM-YYYY");
            if (item.reviewuntildate) item.reviewuntildate = moment(item.reviewuntildate).format("DD-MM-YYYY");
            if (item.simulatedincreamt) item.simulatedincreamt = vm.thousandSeperator(item.simulatedincreamt);
            if (item.finalincreamt) item.finalincreamt = vm.thousandSeperator(item.finalincreamt);
            if (item.simulatedbonusamt) item.simulatedbonusamt = vm.thousandSeperator(item.simulatedbonusamt);
            if (item.finalbonusamt) item.finalbonusamt = vm.thousandSeperator(item.finalbonusamt);
          });
          vm.tableData = res.data.rec;
        } catch (err) {
          vm.errMsg = err;
        }
        this.show = true;
        this.loading = false;
        return;
      }

      let URL;
      if (this.category === "KPI") URL = "/ss/mystaffkpiexercise/stafflist";
      else if (this.category === "Review") URL = "/ss/mystaffreviewexercise/stafflist";

      try {
        const res = await vm.$store.dispatch("get", {
          url: `${URL}/${vm.$store.getters.staffId}/${vm.parentObject.list.id}/${roleId}`,
        });
        vm.currentStaffList = await vm.groupStaffByLeaderOptimized(res.data.rec);
      } catch (err) {
        vm.errMsg = err;
        console.error("Error loading staff list:", err);
      }

      this.show = true;
      this.loading = false;
    },

    thousandSeperator(number) {
      let numStr = number.toString();
      let [integer, decimal] = numStr.split(".");
      integer = integer.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      return decimal ? `${integer}.${decimal}` : integer;
    },

    async groupStaffByLeaderOptimized(rows) {
      if (!rows || rows.length === 0) return [];

      const staffById = new Map();
      const childrenByLeaderId = new Map();

      rows.forEach((r) => {
        if (r.member_id && !staffById.has(r.member_id)) {
          staffById.set(r.member_id, {
            id: r.member_id, staffname: r.member_name, staffcode: r.member_code,
            companyname: r.member_companyname, branchname: r.member_branchname,
            departmentname: r.member_departmentname, sectionname: r.member_sectionname,
            unitname: r.member_unitname, gradedesc: r.member_gradedesc,
            posdesc: r.member_posdesc, statusdesc: r.member_status, pic: r.member_pic,
          });
        }
        if (r.leader_id && !staffById.has(r.leader_id)) {
          staffById.set(r.leader_id, {
            id: r.leader_id, staffname: r.leader_name || `Leader ${r.leader_id}`,
            staffcode: r.leader_code || null, companyname: r.leader_companyname || null,
            branchname: r.leader_branchname || null, departmentname: r.leader_departmentname || null,
            sectionname: r.leader_sectionname || null, unitname: r.leader_unitname || null,
            gradedesc: r.leader_gradedesc || null, posdesc: r.leader_posdesc || null,
            statusdesc: r.leader_status || null, pic: null,
          });
        }
        if (r.leader_id && r.member_id && r.leader_id !== r.member_id) {
          if (!childrenByLeaderId.has(r.leader_id)) childrenByLeaderId.set(r.leader_id, []);
          if (!childrenByLeaderId.get(r.leader_id).includes(r.member_id))
            childrenByLeaderId.get(r.leader_id).push(r.member_id);
        }
      });

      const addedMembers = new Set();

      const buildTree = (leaderId, visited = new Set()) => {
        if (visited.has(leaderId)) return null;
        visited.add(leaderId);
        const leader = staffById.get(leaderId);
        if (!leader) return null;
        const members = [];
        for (const childId of (childrenByLeaderId.get(leaderId) || [])) {
          if (!addedMembers.has(childId)) {
            const childNode = buildTree(childId, new Set(visited));
            if (childNode) { members.push(childNode); addedMembers.add(childId); }
          }
        }
        return { id: leader.id, leader: { ...leader }, members };
      };

      const allLeaderIds = new Set([...childrenByLeaderId.keys()]);
      rows.forEach(r => allLeaderIds.add(r.leader_id));

      const rootNodes = [];
      allLeaderIds.forEach(leaderId => {
        if (!addedMembers.has(leaderId)) {
          const node = buildTree(leaderId);
          if (node) rootNodes.push(node);
          addedMembers.add(leaderId);
        }
      });

      return rootNodes;
    },

    expandAll() { this.expandAllFlag = true; },
    collapseAll() { this.expandAllFlag = false; },

    handleViewDetails(staffData) {
      const vm = this;
      this.$store.dispatch('get', { url: "/ss/mystaff/kpiexercise/" + staffData.staffid + "/" + vm.parentObject.list.id })
        .then(function (res) {
          if (!res.data.rec || res.data.rec.length === 0) {
            vm.errMsg = "No KPI record found for this staff member.";
            return;
          }
          res.data.rec.forEach(item => {
            if (item.startdate) item.startdate = moment(item.startdate).format('DD-MM-YYYY');
            if (item.enddate) item.enddate = moment(item.enddate).format('DD-MM-YYYY');
          });
          vm.$router.push({ name: "selfservicemystaffkpidetails", params: { kpi: res.data.rec[0], list: vm.parentObject.list, roleName: vm.temporaryRole, staffData: staffData } });
        })
        .catch(function (err) { vm.errMsg = err; });
    },

    handleViewReviewDetails(staffData) {
      const vm = this;
      this.$store.dispatch('get', { url: "/ss/mystaff/reviewexercise/" + staffData.staffid + "/" + vm.parentObject.list.id })
        .then(function (res) {
          if (!res.data.rec || res.data.rec.length === 0) {
            vm.errMsg = "No review record found for this staff member.";
            return;
          }
          res.data.rec.forEach(item => {
            if (item.startdate) item.startdate = moment(item.startdate).format('DD-MM-YYYY');
            if (item.enddate) item.enddate = moment(item.enddate).format('DD-MM-YYYY');
          });
          vm.$router.push({ name: "selfservicemystaffreviewdetails", params: { review: res.data.rec[0], list: vm.parentObject.list, roleName: vm.temporaryRole } });
        })
        .catch(function (err) { vm.errMsg = err; });
    },
  },

  async mounted() {
    await this.loadRoleOptions();
    if (this.parentObject.roleName) {
      this.temporaryRole = this.parentObject.roleName;
      await this.refreshList(this.temporaryRole);
    }
  },

  beforeDestroy() {
    this.currentStaffList = [];
    this.tableData = [];
    this.searchQuery = "";
  },
};
</script>

<style scoped>
.mystaff-btn-bar {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 16px 0 8px 0;
}

.mystaff-page-title {
  font-size: 1.1rem;
  font-weight: 600;
  letter-spacing: normal;
  color: #1a3a5c;
  margin-bottom: 12px;
}

.mystaff-main-card {
  background: #ffffff;
  border-radius: 16px;
  border: 1px solid #E8EDF5;
  box-shadow: 0 2px 8px rgba(0,0,0,0.06);
  margin-top: 4px;
  margin-bottom: 24px;
  overflow-y: auto;
  max-height: calc(100vh - 130px);
}

.role-chip {
  display: inline-flex;
  align-items: center;
  font-size: 0.78rem;
  font-weight: 700;
  color: #1261a0;
  background: #EEF2FF;
  border: 1px solid #C7D7FF;
  border-radius: 20px;
  padding: 3px 10px;
  letter-spacing: normal;
}

.fbtn {
  min-width: 90px !important;
  height: 36px !important;
  border-radius: 8px !important;
  font-size: 0.82rem !important;
  font-weight: 600 !important;
  text-transform: none !important;
  letter-spacing: 0.02em !important;
  box-shadow: none !important;
}

.fbtn-cancel {
  background: #F1F5F9 !important;
  color: #64748B !important;
}
.fbtn-cancel:hover {
  background: #E2E8F0 !important;
  color: #334155 !important;
}

.fbtn-secondary {
  background: #EEF2FF !important;
  color: #4F6BFF !important;
}
.fbtn-secondary:hover {
  background: #4F6BFF !important;
  color: #fff !important;
}
</style>
